import { useState } from "react";
import { Icon } from "@mui/material";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import BasicTable from "ui-components/tables/BasicTable";
import { ListLayout } from "ui-components/Layout";
import { DelButton, EditButton } from "ui-components/IconButton";
import { Success, Error, MessageDialog } from "ui-components/Alert";
import {
  getTeamRoleList,
  deactivateTeamRole,
  getTeamRoleStatusCount,
} from "services/data.internal.service";
import BasicTabs from "ui-components/BasicTabs";
import { TableCard } from "ui-components/Layout";
import { useCustomerValue } from "providers/CustomerContext";
import { ActiveButton } from "ui-components/IconButton";
import { activateTeamRole } from "services/data.internal.service";

function TeamRoleList() {
  const navigate = useNavigate();
  const { customerCode } = useCustomerValue()
  const [alert, setAlert] = useState(null);
  const [dialog, setDialog] = useState(null);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState("Active");
  const active = status === "Active" ? true : false;
  const [tabs, setTabs] = useState([]);
  const queryClient = useQueryClient();
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);

  useQuery({
    queryKey: ["team-role-list", { customerCode, active }],
    queryFn: () => getTeamRoleList(active),
    onSuccess: (data) => {
      console.log(data.data.data);
      setData(data.data.data);
    },
    onError,
  });

  useQuery({
    queryKey: ["team-role-status", { customerCode }],
    queryFn: () => getTeamRoleStatusCount(),
    onSuccess: (data) => {
      setTabs(data.data.data);
    },
    onError,
  });

  const delMutation = useMutation(deactivateTeamRole, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(["team-role-status"]);
      queryClient.invalidateQueries(["team-role-list"]);
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });

  const actMutation = useMutation(activateTeamRole, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(["team-role-status"]);
      queryClient.invalidateQueries(["team-role-list"]);
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
  });

  const onDelete = (req) => {
    setDialog(
      <MessageDialog
        title={`Deactivate Team Role ${req.teamName}`}
        onClose={() => setDialog(null)}
        onOk={() => {
          delMutation.mutate(req.teamName);
          setDialog(null);
        }}
      />
    );
  };

  const onActive = (req) => {
    setDialog(
      <MessageDialog
        title={`Activate Team Role ${req.teamName}`}
        onClose={() => setDialog(null)}
        onOk={() => {
          actMutation.mutate(req.teamName);
          setDialog(null);
        }}
      />
    );
  };

  const onEdit = (req) => {
    navigate("/user/team-role/edit", { state: req });
  };

  const columns = [
    { header: "Team Name", accessorKey: "teamName" },
    {
      header: "Action",
      accessorKey: "action",
      enableColumnFilter: false,
      cell: ({ row }) => {
        const { teamName } = row.original;
        return status === "Active" ? (
          <>
            <EditButton title="view and edit team role" onClick={() => onEdit({ teamName })} />
            <DelButton
              title="deactivate team role"
              onClick={() => {
                onDelete({
                  teamName: teamName,
                });
              }}
            />
          </>
        ) : (
          <>
            <ActiveButton title="activate team role" onClick={() => {
              onActive({
                teamName: teamName,
              })
            }} />
          </>
        );
      },
    },
  ];
  return (
    <ListLayout>
      {dialog}
      <MDBox my={3}>
        {alert}
        <BasicTabs tabs={tabs} status={status} setStatus={setStatus} />
      </MDBox>

      <TableCard>
        <MDBox display="flex" justifyContent="space-between" margin="10px">
          <MDButton variant="gradient" color="info" onClick={() => navigate("/user/team-role/add")}>
            <Icon>add</Icon>&nbsp;team&nbsp;role
          </MDButton>
        </MDBox>
        <BasicTable columns={columns} data={data} />
      </TableCard>
    </ListLayout>
  );
}

export default TeamRoleList;
